import { render, staticRenderFns } from "./ResortGuide.vue?vue&type=template&id=02237385"
import script from "./ResortGuide.vue?vue&type=script&lang=js"
export * from "./ResortGuide.vue?vue&type=script&lang=js"
import style0 from "./ResortGuide.vue?vue&type=style&index=0&id=02237385&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports